/**
 @author chunfeng
 @date 2020/4/22 11:56
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;


// 获取快照列表信息
let token01 = null;
export  const getSnapShotList = async (data) => {
    if(token01){
        token01.cancel({statue:'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url:baseUrl.cf[2] + '/GetSnapShotList?',
        method:"get",
        token:token01.token,
    })
}
//获取快照图表详情
let token02 = null;
export const getSnapShotInfo = async (data) => {
    if(token02){
        token01.cancel({statue:'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url:baseUrl.cf[2] + '/GetSnapShotInfo?' +qs.stringify(data),
        method:"get",
        token:token02.toKen,
    })
}

// 获取故事版内容获取详情
export const getTeamSharingContent = async (data) => {
    return axios.ajax({
        url: baseUrl.cf[0] + "/GetStoryBoardInfoBystoryBoardID?" + qs.stringify(data),
        method: "get",
    })
};

// 删除故事版内容中的一项图表 及内容
let token06 = null;
export const removeTeamSharingContentRemove = async (data) => {
    if (token06) {
        token06.cancel({status: 'cancel'});
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/RemoveStoryBoardInfo?",
        method: "get",
        token: token06.token,
    })
};
// 修改故事版内容的zIndex
let token03 = null;
export const setElementContentIndex = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/SaveRankJson",
        method: "post",
        data: data,
        token: token03.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};
// 修改或添加故事版内容详情
let token07 = null;
export const addorModifyTeamSharingContent = async (data) => {
    if (token07) {
        token07.cancel({status: 'cancel'});
    }
    token07 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/SetStoryBoardInfo",
        method: "post",
        data: data,
        token: token07.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//发布故事版图片
let token08 = null;
export const setTeamSharingImg = async (data) => {

    if (token08) {
        token08.cancel({status: 'cancel'});
    }
    token08 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/UploadStoryBoardAsync",
        method: "post",
        data: data,
        token: token08.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};
// 获取故事版添加的图片列表
let token09 = null;
export const getImgList = async () => {
    if (token09) {
        token09.cancel({status: 'cancel'});
    }
    token09 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/GetImageHistoryList",
        method: "get",
        token: token09.token,
    })
};


//修改排他锁状态
let token11 = null;
export const SetInsertExclusiveLock = async (data) => {
    if (token11) {
        token11.cancel({status: 'cancel'});
    }
    token11 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[3] + "/SetInsertExclusiveLock",
        method: "post",
        data: data,
        token: token11.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//提交预览的涂鸦
let token12 = null;
export const setSaveGrafJson = async (data) => {
    if (token12) {
        token12.cancel({status: 'cancel'});
    }
    token12 = axios.token();
    return axios.ajax({
        url: baseUrl.cf[0] + "/SaveGrafJson",
        method: "post",
        data: data,
        token: token12.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


